import { render, staticRenderFns } from "./tagLib.vue?vue&type=template&id=4b4eaea9&scoped=true&"
import script from "./tagLib.vue?vue&type=script&lang=js&"
export * from "./tagLib.vue?vue&type=script&lang=js&"
import style0 from "./tagLib.vue?vue&type=style&index=0&id=4b4eaea9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4eaea9",
  null
  
)

export default component.exports